<template>
<div class="upload-container" :class="type === 'C' ? 'upload-btn' : ''">
  <template v-if="type === 'A'">
    <ul class="image-list">
      <li v-if="imageList.length === 0">
        <el-image src="" fit="cover">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </li>
      <li
        v-for="(img, idx) in imageList"
        :key="idx"
        :class="imageList.length > 0 && limit > 1 && idx == delImgIndex ? 'delSelected' : ''"
        :style="imageList.length > 0 && limit > 1 ? 'cursor: pointer;' : ''"
        @click="selectAction(idx)"
      >
        <el-image :src="img" fit="cover">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </li>
    </ul>
    <el-upload
      class="upload-component"
      :show-file-list="false"
      :with-credentials="true"
      :auto-upload="true"
      :name="name"
      :headers="headers"
      :action="action"
      :fileMaxSize="fileMaxSize"
      :accept="accept"
      :limit="limit"
      :file-list="fileListData"
      :before-upload="beforeUploadFunc"
      :on-change="(file, fileList) => onChangeFunc({file, fileList})"
      :on-success="(response, file, fileList) => onSuccessFunc({response, file, fileList})"
      :on-error="err => onErrorFunc(err)"
      :on-progress="onProgressFunc"
      :disabled="isLoading || (limit > 1 && maxUploadCount)"
      :multiple="multiple"
    >
      <el-button class="egl-btn-yellow" :disabled="isLoading || (limit > 1 && maxUploadCount)">
        {{ $locale("global.upload") }}
      </el-button>
    </el-upload>
    <el-button
      class="egl-btn-red"
      :disabled="isLoading || limit > 1 && delImgIndex < 0"
      @click="deleteAction(delImgIndex)"
      v-if="imageList.length > 0 && imageList[0] !== ''"
    >
      {{ $locale("global.delete") }}
    </el-button>
  </template>

  <template v-if="type === 'B'">
    <div
      class="upload-img" v-for="(imgUrl, i) in imageListGroup"
      :style="uploadImgStyle"
      :src="imgUrl"
      :key="i"
    >
      <div class="not-upload">
        <img src="@/assets/img/img-logo.png" alt="" />
        <p>{{ placeholder }}</p>
        <el-upload
          v-if="showUploadBtn"
          class="upload-component"
          :show-file-list="false"
          :with-credentials="true"
          :auto-upload="true"
          :name="name"
          :headers="headers"
          :action="action"
          :fileMaxSize="fileMaxSize"
          :accept="accept"
          :limit="limit"
          :file-list="fileListData"
          :before-upload="beforeUploadFunc"
          :on-change="(file, fileList) => onChangeFunc({file, fileList, idx: i})"
          :on-success="(response, file, fileList) => onSuccessFunc({response, file, fileList})"
          :on-error="err => onErrorFunc(err)"
          :on-progress="onProgressFunc"
          :disabled="isLoading || (limit > 1 && maxUploadCount)"
        >
          <el-button class="egl-btn-white" style="width: 100%;">{{$locale("global.upload")}}</el-button>
        </el-upload>
      </div>
      <div class="uploaded" v-if="imageList.length > 0 && imageList[i]">
        <el-image :src="imgUrl" fit="cover">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <el-button class="egl-btn-white" @click="deleteAction(i)" size="mini">
          {{$locale("global.delete")}}
        </el-button>
      </div>
    </div>
  </template>

  <template v-if="type === 'C'">
    <el-upload
      class="upload-component"
      :show-file-list="false"
      :with-credentials="true"
      :auto-upload="true"
      :name="name"
      :headers="headers"
      :action="action"
      :fileMaxSize="fileMaxSize"
      :accept="accept"
      :limit="limit"
      :file-list="fileListData"
      :before-upload="beforeUploadFunc"
      :on-change="(file, fileList) => onChangeFunc({file, fileList})"
      :on-success="(response, file, fileList) => onSuccessFunc({response, file, fileList})"
      :on-error="err => onErrorFunc(err)"
      :on-progress="onProgressFunc"
      :disabled="isLoading || (limit > 1 && maxUploadCount)"
    >
      <el-button class="egl-btn-yellow">{{ uploadBtnText }}</el-button>
    </el-upload>
  </template>

  <template v-if="type === 'D'">
    <ul class="image-list">
      <li v-if="imageList.length === 0">
        <el-image src="" fit="cover">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </li>
      <li
        v-for="(img, idx) in imageList"
        :key="idx"
        :class="imageList.length > 0 && limit > 1 && idx == delImgIndex ? 'delSelected' : ''"
        :style="imageList.length > 0 && limit > 1 ? 'cursor: pointer;' : ''"
        @click="selectAction(idx)"
      >
        <el-image :src="img" fit="cover">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </li>
    </ul>
    <el-upload
      ref="upload-D"
      class="upload-component"
      :show-file-list="false"
      :with-credentials="true"
      :auto-upload="true"
      :http-request="uploadFile"
      :name="name"
      :headers="headers"
      :action="action"
      :fileMaxSize="fileMaxSize"
      :accept="accept"
      :limit="limit"
      :file-list="fileListData"
      :before-upload="beforeUploadFunc"
      :on-change="(file, fileList) => onChangeFunc({file, fileList})"
      :disabled="isLoading || (limit > 1 && maxUploadCount)"
      :multiple="multiple"
    >
      <el-button class="egl-btn-yellow" :disabled="isLoading || (limit > 1 && maxUploadCount)">
        {{ $locale("global.upload") }}
      </el-button>
    </el-upload>
    <el-button
      class="egl-btn-red"
      :disabled="isLoading || limit > 1 && delImgIndex < 0"
      @click="deleteAction(delImgIndex)"
      v-if="imageList.length > 0 && imageList[0] !== ''"
    >
      {{ $locale("global.delete") }}
    </el-button>
  </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { uploadFile } from "@/helpers/service/api/common";

export default {
  name: "upload-container",
  props: {
    action: { //upload url
      type: String,
      default: "/api/system/uploadFile",
    },
    name: {
      type: String,
      default: "uploadFile",
    },
    imageList: {
      type: Array,
      default: () => [],
    },
    fileMaxSize: {
      type: Number,
      default: 2 * 1024 * 1024, //2M
    },
    limit: {
      type: Number,
      default: 1,
    },
    accept: {
      type: String,
      default: ".pdf, .png, .jpg, .jpeg, .jpg, .gif", //image files
    },
    type: {
      type: String,
      default: "A", //"A | B | C"
    },
    placeholder: {
      type: String,
      default: function() {
        return this.$locale("shop.plsUpload");
      },
    },
    uploadBtnText: {
      type: String,
      default: function() {
        return this.$locale("global.upload");
      },
    },
    itemWidth: {
      type: Number,
      default: 230,
    },
    itemHeight: {
      type: Number,
      default: 230,
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isLoading: false,
      fileListData: [],
      delImgIndex: 0,
      fileData: "",
    };
  },
  computed: {
    ...mapState("app", {
      token: state => state.token,
    }),
    headers() {
      return {
        "Authorization": this.token,
      };
    },
    maxUploadCount() {
      return this.imageList.length >= this.limit;
    },
    showUploadBtn() {
      let _result = null;

      if (this.limit === 1) {
        _result = this.imageList.length === 0 || (this.imageList.length === 1 && !this.imageList[0]);
      } else if (this.limit > 1) {
        _result = this.imageList.length < this.limit;
      }

      return _result;
    },
    imageListGroup() {
      const _imageList = [ ...this.imageList ];
      if (this.limit === 1) {
        return _imageList;
      } else if (this.limit > 1 && this.imageList.length < this.limit) {
        _imageList.push("");
      }

      return _imageList;
    },
    uploadImgStyle() {
      let _style = "";

      if (this.itemWidth) {
        _style += `width: ${this.itemWidth}px; `;
      }
      if (this.itemHeight) {
        _style += `height: ${this.itemHeight}px; `;
      }

      return _style;
    },
  },
  methods: {
    onChangeFunc(options) {
      this.$emit("onChange", options);
    },
    onSuccessFunc(options) {
      console.log(options);
      const { success, message } = options.response || {};
      this.fileListData = [];
      if (success) {
        this.isLoading = false;
        this.$emit("onSuccess", options);
      } else {
        this.isLoading = false;
        this.handleErrorFunc(message);
      }
    },
    onErrorFunc(err) {
      const { message, status } = err;
      let _errObj = "";

      if (status === 413) {
        this.uploadFileOverSize();
      }

      if (typeof message === "string") {
        _errObj = message.replace("Error:", "");
        _errObj = JSON.parse(_errObj);
      }

      this.fileListData = [];
      this.handleErrorFunc(_errObj.message);
      this.isLoading = false;
      this.$emit("onError", err);
    },
    uploadSuccessFunc(options) {
      if (options.file.status === "sucess") {
        this.$emit("onSuccess", options);
      } else {
        this.handleErrorFunc();
      }
    },
    onProgressFunc() {
      this.isLoading = true;
    },
    beforeUploadFunc(file) {
      let _result = true;
      if (file.size > this.fileMaxSize) {
        _result = false;
        this.uploadFileOverSize();
        this.fileListData = [];
      }

      return _result;
    },
    handleErrorFunc(err = this.$locale("err.uploadError")) {
      //TODO: handle upload error!!!
      this.$alert(err, { showClose: false });
    },
    deleteAction(idx) {
      this.$emit("onDelete", idx);
      if (this.type === "A") {
        this.delImgIndex = this.imageList === 0 ? -1 : 0;
      }
    },
    selectAction(_idx) {
      if (this.imageList.length < 1 || this.limit === 1) { return; }
      this.delImgIndex = _idx;
    },
    uploadFileOverSize() {
      this.isLoading = false;
      if (this.fileMaxSize === 1024 * 1024) {
        this.$alert(this.$locale("err.uploadFileTooLarge-1M"), {
          showClose: false,
        });
      } else {
        this.$alert(this.$locale("err.uploadFileTooLarge"), {
          showClose: false,
        });
      }
    },
    async uploadFile(file) {
      const _file = file.file;
      let formData = new FormData();
      formData.append("uploadFile", _file);
      return await uploadFile(formData).then(res => {
        this.$emit("onSuccess", res);
      });
    },
  },
};
</script>

<style scoped lang="less">
.upload-container {
  display: inline-block;

  .upload-component {
    display: inline-block;

    & +.el-button {
      margin-left: 10px;
    }
  }

  .image-list {
    list-style: none;
    margin: 0;
    padding: 0;

    > li {
      display: inline-block;
      width: 160px;
      height: 160px;
      margin: 10px 20px 10px 0;
      border: 2px solid transparent;
      background-color: #f8f8f8;

      .el-image {
        width: 100%;
        height: 100%;
      }

      &:last-child {
        margin-right: 0;
      }

      &.delSelected {
        position: relative;
        border: 2px solid @primary-red;
        background-color: @pure-white;

        &::before {
          content: "";
          position: absolute;
          z-index: 2;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          background: rgba(255, 255, 255, .3);
        }
      }

      ::v-deep .image-slot {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;

        > i {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -1.5rem;
          margin-left: -1.5rem;
          font-size: 3rem;
        }
      }
    }
  }

  .upload-img {
    display: inline-block;
    position: relative;
    // width: 230px;
    // height: 230px;
    min-width: 60px;
    min-height: 60px;
    margin-right: 20px;
    background: @light-grey-bg;
    overflow: hidden;

    &:last-child {
      margin-right: 0;
    }

    &:before {
      content: "";
      display: block;
      padding-top: 100%;
    }

    .not-upload,
    .uploaded {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    .not-upload {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        // margin-bottom: 5%;
        vertical-align: top;
        width: 20%;
        max-width: 38px;
      }

      p {
        color: @other-grey;
        font-size: 1rem;
        line-height: 1.2;
        margin: 5% 0;
        padding: 0 20px;
        text-align: center;
        white-space: pre-line;
      }

      // .el-button {
        // margin-top:f 5%;
        // width: 160px;
      // }
    }

    .uploaded {
      .el-image {
        width: 100%;
        height: 100%;
      }

      .el-button {
        position: absolute;
        width: 60px;
        height: auto;
        bottom: 20px;
        left: 50%;
        margin-left: -30px;
      }
    }
  }

  &.upload-btn {
    margin-left: 10px;
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
